import { Component, Input } from '@angular/core';
import { DsChipColorVariant, DsColors, IconStyles, Icons } from '@levelaccess/design-system';
import { $severity } from '../../../../../../../shared/constants/accessibility';
import { SeverityChipUtility } from '../../../../../utility/severity-chip.utility';
import { ICellConfig } from '../base-cell/base-cell.component';
import { BaseCellComponent } from '../base-cell/base-cell.component';

export interface ISeverityCellConfig extends ICellConfig {
  severity: $severity;
  text?: string;
}

@Component({
  selector: 'table-cell-severity',
  styleUrls: ['../base-cell/base-cell.component.scss'],
  standalone: false,
  template: `
    <div #ref class="severity-block">
      <ds-chip
        [text]="(config.text | titlecase) || ('scan_issue_severity_' + config.severity | translate)"
        [colorVariant]="getSeverityChipVariant(config.severity)"
        [showIcon]="true"
        [iconName]="getSeverityIcon(config.severity)"
        [iconStyle]="IconStyles.Regular"
        [iconColor]="getSeverityIconColor(config.severity)"
      ></ds-chip>
    </div>
  `,
})
export class SeverityCellComponent extends BaseCellComponent {
  @Input() public config: ISeverityCellConfig;
  public $severity: typeof $severity = $severity;
  public readonly DsChipColorVariant: typeof DsChipColorVariant = DsChipColorVariant;
  public readonly IconStyles: typeof IconStyles = IconStyles;

  public getSeverityIconColor(severity: $severity): keyof typeof DsColors {
    return SeverityChipUtility.getIconColor(severity);
  }

  public getSeverityChipVariant(severity: $severity): DsChipColorVariant {
    return SeverityChipUtility.getChipVariant(severity);
  }

  public getSeverityIcon(severity: $severity): Icons {
    return SeverityChipUtility.getIcon(severity);
  }
}
